{
 "_meta": {
  "locale": "nl",
  "status": "partial",
  "note": "Shell translation (draft, needs native review). Missing keys fall back to English."
 },
 "nav": {
  "today": "Nu",
  "people": "Personen",
  "cases": "Dossiers",
  "agenda": "Agenda",
  "reviews": "Evaluaties",
  "prospects": "Prospectie",
  "insights": "Inzichten",
  "data": "Gegevens & veiligheid",
  "settings": "Instellingen",
  "lens": "Loep"
 },
 "common": {
  "save": "Opslaan",
  "cancel": "Annuleren",
  "close": "Sluiten",
  "search": "Zoeken",
  "today": "Vandaag",
  "tomorrow": "Morgen",
  "new": "Nieuw",
  "edit": "Bewerken",
  "delete": "Verwijderen"
 },
 "settings": {
  "title": "Instellingen",
  "language": "Taal",
  "region": "Markt / regio",
  "theme": "Weergave"
 },
 "people": {
  "title": "Personen",
  "new": "Nieuwe persoon"
 },
 "today": {
  "agenda_title": "Vandaag"
 },
 "lens": {
  "placeholder": "Zoek personen, prospects, dossiers — of typ een opdracht"
 }
}